import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import "./Stepper.css"; // Custom CSS for the stepper
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Modal, Button, Pagination } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faMapMarkerAlt, faPlus, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import AddPemeDetails from "./addPemeAppointments";

function BookPemeAppointments() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState("");
    const [labs, setLabs] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("");
    const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
    const [savedDetailsList, setSavedDetailsList] = useState([]);
  
    const token = JSON.parse(localStorage.getItem("data")).token;

    const [pemeDetails, setPemeDetails] = useState({
        labId: "",
        appointmentDate: "",
        companyId:"",
      pemeDetails: {
        fullName: "",
        phoneNumber: "",
        gender: "",
        dob: "",
        companyId: "",
        email: "",
        address: "",
        pemeDocuments: [
            {
                file:null,
                fileContentType:"",
                fileSize:"",
                fileName:""
            }
        ],
      },
    });
  
    useEffect(() => {
      getCities();
      getCompanies();
    }, []);
  
    const getCities = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/api/labdetails/getUniqueCities`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCities(response.data);
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    };
  
    const getCompanies = async () => {
      try {
        const response = await axios.get(`/api/companydetails/getCompaniesByAdminlink`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCompanies(response.data);
      } catch (error) {
        handleError(error);
      }
    };
  
    const handleCityChange = (e) => {
      const city = e.target.value;
      setSelectedCity(city);
  
      if (city) {
        axios
          .post(
            `/api/labdetails/getLabsByCity`,
            { city },
            { headers: { Authorization: `Bearer ${token}` } }
          )
          .then((response) => setLabs(response.data))
          .catch((error) => console.error("Error fetching labs:", error));
      } else {
        setLabs([]);
      }
    };
    
    const handleInputChange = (e) => {
      const { id, value } = e.target;

      if(id==="appointmentDate"){
        const selectedDate = new Date(value);
   
           if (selectedDate.getDay() === 0) {
                 toast.warn("Please select a weekday other than Sunday.");
                 return;
               }
        
      }
    
      setPemeDetails((prevState) => {
        
          return {
            ...prevState,
            [id]: value,
          };
        })
    };
    
  
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (savedDetailsList.length === 0) {
          toast.error("Please add at least one user before submitting.");
          return;
      }
        setLoading(true);
      
        const requestBody = {
            labId: pemeDetails.labId,
            appointmentDate: pemeDetails.appointmentDate,
            companyId: pemeDetails.companyId,
            pemeDetails: savedDetailsList.map(detail => ({
              fullName: detail.fullName,
              phoneNumber: detail.phoneNumber,
              gender: detail.gender,
              dob: detail.dob,
              companyId: pemeDetails.companyId,
              email: detail.email,
              address: detail.address,
              pemeDocuments: detail.pemeDocuments.map(doc => ({
                file: doc.file,
                fileContentType: doc.fileContentType,
                fileSize: doc.fileSize,
                fileName:doc.fileName
              }))
            }))
          };
          
        try {
          const response = await axios.post("/api/createPemeDetailsAndAppointments", requestBody, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
      
          if (response.status === 200) {
            toast.success("PEME Appointment booked successfully");
            navigate(`/users/pemeAppointments`);
          }
        } catch (error) {
         handleError(error);
        } finally {
          setLoading(false);
        }
      };
      
    
    function handleError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          navigate(`/signin`);
          toast.error("Your session has expired. Please login.");
        } else {
          toast.error(error.response.data?.message || "An error occurred.");
        }
      } else {
        toast.error(error.message || "An error occurred.");
      }
    }
  
    const [selectedUser, setSelectedUser] = useState(null);

    const handleAddUser = async () => {
      if (!pemeDetails.labId || !pemeDetails.appointmentDate || !pemeDetails.companyId) {
        alert("Please fill all required fields: Lab, Appointment Date, and Company.");
        return;
      }
    
      try {
        // API call to check if package exists for the given companyId
        const response = await axios.get(`/api/companydetails/${pemeDetails.companyId}`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.data.pemePackageId!==null) {
          setSelectedUser(null);
          setIsAddUserModalOpen(true);
        } else {
          toast.error("No package linked to this company.");
        }
      } catch (error) {
       handleError(error);
      }
    };
  const handleCloseAddUserModal = () => setIsAddUserModalOpen(false);

  const handleSaveDetails = (data) => {
    setSavedDetailsList((prevList) => {
        const existingIndex = prevList.findIndex((item) => item.id === data.id);

        if (existingIndex !== -1) {
            // If the ID exists, replace the existing entry
            const updatedList = [...prevList];
            updatedList[existingIndex] = { ...prevList[existingIndex], ...data };
            return updatedList;
        } else {
            // If it's a new entry, add it to the list
            return [...prevList, data];
        }
    });
};

      
      useEffect(() => {
      }, [savedDetailsList]); // Runs whenever savedDetailsList changes
      
      const handleRemoveUser = (index) => {
        setSavedDetailsList((prevList) => prevList.filter((_, i) => i !== index));
      };
      
      const handleViewUser = (user) => {
        setSelectedUser(user); 
        setIsAddUserModalOpen(true);  
    };
 
  return (
    <div>
      <div>
        <AdminDashboard />
      </div>
      {loading && <div className="loading"></div>}
      <div className="col-10 mx-xl-auto ps-xl-10 mt-10">
      <div className="card card-raised ">
            <div className="card-body ">
              <div className="card-title form-group d-flex align-items-center justify-content-between">
                Book Appointments
              </div>
              <br/>
      <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-2">
              <label>City <span style={{ color: "maroon" }}>(Required)</span></label>
              <select className="form-select" onChange={handleCityChange} required>
                <option value="">Select City</option>
                {cities.map((city, index) => (
                  <option key={index} value={city}>{city}</option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-2">
              <label>Lab <span style={{ color: "maroon" }}>(Required)</span></label>
              <select className="form-select" id="labId" value={pemeDetails.labId} onChange={handleInputChange} required>
                <option value="">Select Lab</option>
                {labs.map((lab) => (
                  <option key={lab.id} value={lab.id}>{`${lab.labname} (${lab.labcode})`}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
                <div className="col-md-6">
                  <div className="form-floating-sm mb-2">
                    <label htmlFor="appointmentDate">Appointment Scheduler <span style={{color:"maroon"}}>(Required)</span></label>
                    <input
                      className="form-control"
                      id="appointmentDate"
                      type="date"
                      value={pemeDetails.appointmentDate}
                      onChange={handleInputChange}
                      min={new Date().toISOString().split("T")[0]}
                      required
                    />
                   </div>
                  </div>

            <div className="col-md-6 mb-2">
              <label>Company <span style={{ color: "maroon" }}>(Required)</span></label>
              <select className="form-select" id="companyId" value={pemeDetails.companyId} onChange={handleInputChange} required>
                <option value="">Select Company</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.id}>{company.companyname}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between mt-4">
    <h5>Users:</h5>
    <Button variant="success" onClick={handleAddUser}>
        <FontAwesomeIcon icon={faPlus} />
    </Button>
</div>

<br/>
          <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Gender</th>
                    <th>Date of Birth</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                {savedDetailsList.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  ) : (
                    savedDetailsList.map((detail, index) => {
                      return (
                        <tr key={index}>
                        <td>{index + 1}</td>
                          <td>{detail.fullName} </td>
                          <td>{detail.email}</td>
                          <td>{detail.phoneNumber}</td>
                          <td>{detail.gender}</td>
                          <td>{detail.dob}</td>
                          <td>
    <div className="d-flex align-items-center gap-2">
        <Button variant="info" size="sm" onClick={() => handleViewUser(detail)}>
            <FontAwesomeIcon icon={faEye}/>
        </Button>
        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleRemoveUser(index)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
        </Button>
    </div>
</td>

                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>

          <Button type="submit" variant="primary" disabled={loading}>Submit</Button>
        </form>

    </div>
    </div>

    {isAddUserModalOpen && (
           <AddPemeDetails isOpen={isAddUserModalOpen} onRequestClose={handleCloseAddUserModal} onSave={handleSaveDetails} userDetails={selectedUser}/>
           )}
    </div>
    </div>
  );
}

export default BookPemeAppointments;
